import * as actions from './actions';
import Model from '../model';
import request from 'superagent';
import { toast } from 'react-toastify';
import FileManager from '/app/src/lib/FileManager.js';

class Employee extends Model {

    create(userName, userEmail, userRole) {
        return (dispatch) => {
            const url = this.url()
            const token = this.token()
            dispatch(actions.employeeCreateRequest());
            return request
                .post(`${url}/v2/employee`)
                .send({
                    user_name: userName,
                    user_email: userEmail,
                    user_role: userRole
                })
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        const employee = res.body.employee;
                        dispatch(actions.employeeCreateSuccess(employee))
                        toast.success('Användare har lagt till i system.')
                    }else if (res.statusCode === 400){
                        if(res.body.error && res.body.error === 'User email already existed'){
                            toast.error('Användare med den e-postadress finns redan. Kontakta Jibber så hjälper vi dig.')
                        }else{
                            toast.error('Någonting gick fel. Kontakta Jibber så hjälper vi dig.')
                        }
                    } else {
                        dispatch(actions.employeeCreateFailure(err, res))
                        toast.error('Någonting gick fel. Kontakta Jibber så hjälper vi dig.')
                    }
                });
        }
    }
    isOnline(userId){
        return (dispatch) => {
            dispatch(actions.employeeIsOnline(userId))
        }
    }
    isOffline(userId){
        return (dispatch) => {
            dispatch(actions.employeeIsOffline(userId))
        }
    }

    puts(employees)
    {
        return (dispatch) => {
          dispatch(actions.employeesPut(employees));
        }
    }

    setIsLoading()
    {
        return (dispatch) => {
          dispatch(actions.setLoading());
        }
    }

    deleteEmployeesProfileImg(id){
        return (dispatch) => {
            const url = this.url()
            const token = this.token()

            return request
                .post(`${url}/v1/me/update`)
                .send({
                    updates: {image_url: ''}
                })
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200)
                    {
                       dispatch(actions.setEmployeesProfileImg('', id));
                       dispatch(actions.setEmployeesProfileImgSuccess());
                       toast("Profilbild borttagen");
                    }
                    else
                    {
                        toast.error('Någonting gick fel. Kontakta Jibber så hjälper vi dig!')
                    }
                });
        }
    }

    //Relevant employee is needed to map correctly in Redux
    uploadProfileImage(blob, id) {
        //TODO: Check success
        const url = this.url()
        const token = this.token()
        const routePath = '/v1/employee/image/upload_url'
        return (dispatch) => {
            FileManager
            .uploadFile(blob, url + routePath, token)
            .then((err, res) => {
                return request
                .post(url+routePath)
                .send({})
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .set('Authorization', 'Bearer ' + token)
            })
            .then((result) => {
                const status = result.status;

                if(status === 200){
                    toast("Snyggt! Din nya profilbild är nu uppladdad :)");
                    const imgUrl = result.body.image_url
                    dispatch(actions.setEmployeesProfileImg(imgUrl+'?'+Date.now(), id))
                    dispatch(actions.setEmployeesProfileImgSuccess());
                }else{
                    console.log('Ojoj nu gick något fel här');
                }
            })
        }
    }

    changePassword() {
        const network = this.networkSelector.create('EMPLOYEE_CHANGE_PASSWORD')

        const selectorFunction = (state) => {
            return {
                'network': network.getFrom(state)
            }
        }

        const dispatchFunction = (currentPass, newPass, newPassRepeat)=>{
            return (dispatch) => {
                let url = this.url();
                let token = this.token();
                dispatch(network.request());
                request
                .put(`${url}/v1/employee/password`)
                .send({'old_password': currentPass, 'new_password': newPass, 'new_password_repeat': newPassRepeat})
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .set('Authorization', 'Bearer ' + token)
                .end((err, res) => {
                    if (res.statusCode === 401) {
                        toast.failure('Fel lösenord!');
                        dispatch(network.failure('wrong password'));
                    } else if (res.statusCode === 200) {
                        toast.success('Ditt lösenord har uppdaterats.');
                        dispatch(network.success());
                    }
                });
            }
        }
        return {selector: selectorFunction, dispatcher: dispatchFunction }
    }

    update(employeeId, role) {
        return (dispatch) => {
            let url = this.url();
            let token = this.token();
            request
            .put(`${url}/v1/employee/${employeeId}/update`)
            .send({updates:
                {role: role}
                })
            .accept('application/json')
            .set('Content-Type', 'application/json')
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {

                if (res.statusCode === 401)
                {
                    toast('Fel lösenord!');
                }
                else if (res.statusCode === 200)
                {
                    toast('Användarroll ändrat')
                }

            });
        }
    }


    updateName(employeeId, name)
    {
        return (dispatch) => {
            let url = this.url();
            let token = this.token();
            request
            .put(`${url}/v1/employee/${employeeId}/update`)
            .send({updates:
                {name: name}
                })
            .accept('application/json')
            .set('Content-Type', 'application/json')
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {

                if (res.statusCode === 401)
                {
                    toast('Fel lösenord!');
                }
                else if (res.statusCode === 200)
                {
                    dispatch(actions.setEmployeeName(employeeId, name));
                    toast('Användarnamn ändrat')
                }

            });
        }
    }


    updateDisplayName(employeeId, displayName)
    {
        return (dispatch) => {
            let url = this.url();
            let token = this.token();
            request
            .put(`${url}/v1/employee/${employeeId}/update`)
            .send({updates:
                {display_name: displayName}
                })
            .accept('application/json')
            .set('Content-Type', 'application/json')
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {

                if (res.statusCode === 401)
                {
                    toast('Fel lösenord!');
                }
                else if (res.statusCode === 200)
                {
                    dispatch(actions.setEmployeeDisplayName(employeeId, displayName));
                    toast('Displaynamn ändrat')
                }

            });
        }
    }


    delete(employeeId){
        return (dispatch) => {
            let url = this.url();
            let token = this.token();
            dispatch(actions.employeeDeleteRequest());
            request
            .post(`${url}/v1/employee/${employeeId}/delete`)
            .send({employee_id: employeeId.toString()})
            .accept('application/json')
            .set('Content-Type', 'application/json')
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {

                if (res.statusCode === 401)
                {
                    dispatch(actions.employeeDeleteFailure());
                    toast('Användaren kunde inte tas bort');
                }
                else if (res.statusCode === 200)
                {
                    dispatch(actions.employeeDeleteSuccess(employeeId));
                    toast('Användaren borttagen');
                }

            });
        }
    }
}
export default new Employee()



// WEBPACK FOOTER //
// ./src/model/Employee/model.js